import React from 'react';

const Icon = ({ width = '19', height = '9', fill = 'black', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 19 9" fill="none" {...other}>
            <foreignObject x="-34.803" y="-34.468" width="89.004" height="78.66">
                <div xmlns="http://www.w3.org/1999/xhtml" style={{ backdropFilter: 'blur(17.72px)', height: '100%', width: '100%' }} clipPath="url(#a)" />
            </foreignObject>
            <path data-figma-bg-blur-radius="35.44" d="M1.135 8.721a.354.354 0 0 1-.49-.399L2.222.972h16.54L1.135 8.723Z" fill={fill} fillOpacity="0.3" />

            <defs>
                <clipPath id="a" transform="translate(34.803 34.468)">
                    <path d="M1.135 8.721a.354.354 0 0 1-.49-.399L2.222.972h16.54L1.135 8.723Z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
